var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"htbox",on:{"click":function($event){return _vm.handleFuc2(_vm.moduleName)}}},[_c('img',{attrs:{"src":_vm.filteru(_vm.moduleName)}}),_c('p',[_vm._v(_vm._s(this.$t(_vm.moduleName)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }